import { STORE_API_LOADING } from "actions"

export const initialState = {
  apiLoading: false,
  error: {
    message: "",
  },
}

export const agreementCards = (state = initialState, action) => {
  switch (action.type) {
    case STORE_API_LOADING:
      return { ...state, apiLoading: action.payload }
    default:
      return state
  }
}

export default agreementCards
